import {
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  //Paper,
  Box,
  Checkbox,
  Button,
  Chip,
} from "@mui/material";
import GenericModal from "../../Modal/GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ChangeEvent, useContext, useState, useEffect } from "react";
import { AUTODELRULATE_AD_LINK } from "../../Utils/Constants";
import { CacheContext } from "../../Context/cacheContext";
import { postData } from "../../Services/postData";
import { getData } from "../../Services/getData";
import {
  WEBSITE_INTEGRATIONS,
  WebsiteModel,
} from "../../Utils/websiteIntegrations";
import { getActiveLocations } from "../../Utils/utils";
import { urlEnum } from "../../Utils/urlEnum";
//import InsertLinkIcon from "@mui/icons-material/InsertLink";

export interface ModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  vehicle: any | null;
  setVehicle: (data: any) => void;
  getDataRefresh: () => void;
}

export default function PostAdsIntegrationModal(props: ModalProps) {
  const { open, setOpen, vehicle, setVehicle, getDataRefresh } = props;
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [newCar, setNewCar] = useState({});
  const [websiteLocations, setWebsiteLocations] = useState<any>({});
  const [data, setData] = useState({});
  const [availableWebsites, setAvailableWebsites] = useState<WebsiteModel[]>(
    []
  );
  const cache = useContext(CacheContext)?.cache;
  const locations = getActiveLocations(cache?.locations);

  /**
   * Fetch available websites for the vehicle's location
   */
  useEffect(() => {
    if (open && vehicle?.locatie_administrativa_id) {
      getData(
        `${urlEnum.websitesIntegration}/available/${vehicle.locatie_administrativa_id}`
      )
        .then((response: any) => {
          // Filter WEBSITE_INTEGRATIONS to only include those available for this location
          const availableTypes =
            response?.data?.data?.map((int: any) => int?.type) || [];
          const filtered = WEBSITE_INTEGRATIONS.filter(
            (website) =>
              availableTypes.includes(website.code) ||
              website.code === "autodelrulate"
          );
          setAvailableWebsites(filtered);
        })
        .catch(() => {
          // Fall back to all websites if API fails
          setAvailableWebsites(WEBSITE_INTEGRATIONS);
        });
    }
  }, [open, vehicle?.locatie_administrativa_id]);
  /**
   *
   * @param url
   */
  const postAds = async () => {
    try {
      availableWebsites.forEach(async (website: WebsiteModel) => {
        const websiteCode = website?.code;
        if (Object.assign(data)[website.code]) {
          const vehicleId = vehicle
            ? vehicle["id" as keyof typeof vehicle]
            : "null";

          // If URL already has ?, split and insert vehicle ID
          const url = website.url.includes("?")
            ? website.url.replace("?", `/${vehicleId}?`)
            : `${website.url}/${vehicleId}`;
          const isNewCar = Object.assign(newCar)[websiteCode];

          //get selected locations for this website
          const selectedLocations = websiteLocations[websiteCode] || [];
          const selectedLocationIds = selectedLocations.map(
            (loc: any) => loc.id
          );

          const response = await postData(url, {
            isNewCar,
            selectedLocationIds,
          });

          if (response?.status == 200 && response?.data) {
            setVehicle(response?.data?.vehicle);
            setShouldRefresh(true);
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   *
   * @param advertUrlData
   * @returns
   */
  const renderAdvertUrl = (advertUrlData: any) => {
    const advertUrl = JSON.parse(advertUrlData);
    const advertUrlParsed = advertUrl["advert_url"].split(",");
    return advertUrlParsed.map((url: string) => {
      return (
        <a
          style={{
            textDecoration: "none",
            color: "black",
            cursor: "pointer",
            wordBreak: "break-word",
          }}
          rel="noreferrer"
          target="_blank"
          href={url}
        >
          {url}
        </a>
      );
    });
  };

  /**
   *
   */
  const onClose = () => {
    setOpen(false);
    if (shouldRefresh) {
      // sa faca refresh la date doar daca a fost postat un anunt
      getDataRefresh();
      setShouldRefresh(false);
    }
    setNewCar({});
  };

  return (
    <>
      <GenericModal
        open={open}
        onClose={onClose}
        title={Vocabulary.postAd}
        subtitle={
          vehicle?.locatie_administrativa_r?.nume ? (
            <Chip
              label={`${Vocabulary.vehicleLocation}: ${vehicle.locatie_administrativa_r.nume}`}
              color="primary"
              size="small"
              style={{ marginTop: "0.5rem" }}
            />
          ) : null
        }
        buttons={
          <Grid container spacing={3} style={{ padding: "1rem" }}>
            <Grid item md={6} xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={onClose}
              >
                {Vocabulary.cancel}
              </Button>
            </Grid>
            <Grid item md={6} xs={12}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                style={{ color: "white", height: "95%" }}
                onClick={() => {
                  postAds();
                }}
              >
                {Vocabulary.sync}
              </Button>
            </Grid>
          </Grid>
        }
        children={
          <Grid container spacing={2}>
            {availableWebsites.map((website: WebsiteModel) => {
              const advertUrl = vehicle
                ? website?.code == "autodelrulate" &&
                  vehicle["slug" as keyof typeof vehicle]
                  ? JSON.stringify({
                      advert_url:
                        AUTODELRULATE_AD_LINK +
                        vehicle["slug" as keyof typeof vehicle],
                    }) ?? null
                  : vehicle[
                      (website.code.toLowerCase() +
                        "_advert_data") as keyof typeof vehicle
                    ]
                : null;

              // const isPostableOnWebsite = vehicle
              //   ? vehicle[
              //       ("is_postable_on_" +
              //         website.code.toLowerCase()) as keyof typeof vehicle
              //     ]
              //   : null;
              return (
                <>
                  <Grid item md={12} xs={12}>
                    <Box
                      style={{
                        padding: "1rem",
                        borderRadius: "7px",
                        backgroundColor: "#fff !important",
                        boxShadow:
                          "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
                        position: "relative",
                      }}
                    >
                      {/* Website Selection - Main Switch */}
                      <FormControlLabel
                        label={
                          <Typography
                            style={{ fontSize: "1.3rem", fontWeight: 600 }}
                          >
                            {website.name}
                          </Typography>
                        }
                        control={
                          <Switch
                            // disabled={!isPostableOnWebsite}
                            //defaultChecked={advertUrl ? true : false}
                            onChange={async (
                              e: ChangeEvent<HTMLInputElement>
                            ) => {
                              setData({
                                ...data,
                                [website.code]: e.target.checked,
                              });
                            }}
                          />
                        }
                      />

                      {/* Divider */}
                      <Box
                        style={{
                          borderTop: "1px solid #e0e0e0",
                          margin: "0.75rem 0",
                        }}
                      />

                      {/* Options Section */}
                      <div style={{ paddingLeft: "0.5rem" }}>
                        {/* New Car Checkbox */}
                        <div style={{ marginBottom: "0.5rem" }}>
                          <FormControlLabel
                            label={
                              <Typography style={{ fontSize: "0.95rem" }}>
                                {Vocabulary.newCar}
                              </Typography>
                            }
                            control={
                              <Checkbox
                                defaultChecked={false}
                                onClick={(event: any) => {
                                  setNewCar({
                                    [website.code]: event.target.checked,
                                  });
                                }}
                              />
                            }
                          />
                        </div>

                        {/* Locations Section */}
                        {locations?.length > 0 && (
                          <div>
                            <Typography
                              style={{
                                fontSize: "0.85rem",
                                fontWeight: 600,
                                color: "#666",
                                marginBottom: "0.5rem",
                                //  textTransform: "uppercase",
                                // letterSpacing: "0.5px"
                              }}
                            >
                              {Vocabulary.locationsForPhotos}:
                            </Typography>
                            <Box
                              style={{
                                display: "grid",
                                gridTemplateColumns:
                                  "repeat(auto-fill, minmax(150px, 1fr))",
                                gap: "0.25rem",
                                padding: "0.5rem",
                                backgroundColor: "#f9f9f9",
                                borderRadius: "4px",
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              {locations.map((location: any) => {
                                return (
                                  <FormControlLabel
                                    key={location.id}
                                    label={
                                      <Typography
                                        style={{ fontSize: "0.9rem" }}
                                      >
                                        {location.nume}
                                      </Typography>
                                    }
                                    control={
                                      <Switch
                                        defaultChecked={false}
                                        size="small"
                                        onChange={(e) => {
                                          const currentLocations =
                                            websiteLocations[website.code] ||
                                            [];
                                          const updatedLocations = e.target
                                            .checked
                                            ? [...currentLocations, location]
                                            : currentLocations.filter(
                                                (loc: any) =>
                                                  loc.id !== location.id
                                              );
                                          setWebsiteLocations({
                                            ...websiteLocations,
                                            [website.code]: updatedLocations,
                                          });
                                        }}
                                      />
                                    }
                                    style={{ margin: 0 }}
                                  />
                                );
                              })}
                            </Box>
                          </div>
                        )}
                      </div>
                      {
                        //se afiseaza link-ul catre anunt doar daca el exista si nu se poate reposta un nou anunt
                        //adica inca nu a expirat anuntul curent
                        advertUrl && (
                          <>
                            <Typography
                              style={{
                                fontSize: "1rem",
                                padding: "0.5rem",
                                marginTop: "1rem",
                              }}
                            >
                              {Vocabulary.advertLink}{" "}
                            </Typography>
                            <Typography
                              style={{
                                fontSize: "1rem",
                                fontWeight: "600",
                                width: "100%",
                                padding: "0 0.5rem",
                              }}
                            >
                              {renderAdvertUrl(advertUrl)}
                            </Typography>
                          </>
                        )
                      }
                    </Box>
                  </Grid>
                </>
              );
            })}
          </Grid>
        }
      />
    </>
  );
}
